import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import AddPSUAccessComponent from '../../components/AddPSUAccessComponent/AddPSUAccessComponent'

const AddPSUAccess = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <AddPSUAccessComponent/>
                </div>
            </div>
        </div>
    )
}

export default AddPSUAccess
